import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { getCustomerCodeDetails, submitCustomerCodeRequest } from "./CustomerCodeAction";

// import {
//   getRegistrationDetails,
// } from "./actions/Registration";

interface ICustomerCodeList {
  liner: string;
  linerName: string | ""; 
  customerCode: string;
  matchCode: string;
  id: string;
}


export interface ICustomerCodeSlice {

  isSubmitted: boolean;
  countryOptions: any;
  selectedCountry: string;
  linerOptions: any;
  customerCodeDataList: Array<ICustomerCodeList>;
  partnerTable: Array<{
    rowNumber: any;
    customerCode: String;
    liner: String;
    attachmentName: String;
    serverPath: String | null;
    serverName: String | null;
    loading: undefined | number;
    remove: true;
    m: boolean;
    error: {
      attachment: boolean;
      customerCode: boolean;
    };
    customerCodeErrorMessage: string;
  }>;

}

const initialState: ICustomerCodeSlice = {

  countryOptions: [],
  isSubmitted: false,
  linerOptions: [],
  customerCodeDataList: [],
  selectedCountry: "",
  partnerTable: [
    {
      rowNumber: crypto.randomUUID(),
      customerCode: "",
      liner: "",
      attachmentName: "",
      serverName: null,
      serverPath: null,
      loading: 0,
      remove: true,
      m: true,
      error: {
        attachment: false,
        customerCode: false,
      },
      customerCodeErrorMessage: "",
    },
  ],


};

export const CustomerCodeReducer = createSlice({
  name: "customerCodeReducer",
  initialState,
  reducers: {

    updateCountryOptions: (state, action: PayloadAction<any>) => {
      state.countryOptions = action.payload;
    },

    updateLinerOptions: (state, action: PayloadAction<any>) => {
      state.linerOptions = action.payload;
    },

    addPartnerTableRow: (state, action) => {
      state.partnerTable.push({
        rowNumber: action.payload.key,
        customerCode: "",
        liner: state.linerOptions[0]?.value ?? "",
        attachmentName: "",
        serverName: null,
        loading: 0,
        serverPath: null,
        remove: true,
        m: action.payload.m,
        error: {
          attachment: false,
          customerCode: false,
        },
        customerCodeErrorMessage: "",
      });
    },

    removePartnerTableRow: (state, action) => {
      if (state.partnerTable.length <= 1) {
        state.partnerTable = [
          {
            rowNumber: action.payload.key,
            customerCode: "",
            liner: state.linerOptions[0]?.value ?? "",
            attachmentName: "",
            serverName: null,
            loading: 0,
            serverPath: null,
            remove: true,
            m: action.payload.m,
            error: {
              attachment: false,
              customerCode: false,
            },
            customerCodeErrorMessage: "",
          },
        ];
        return;
      }
      state.partnerTable = state.partnerTable.filter(
        (i) => i.rowNumber !== action.payload.rowNumber
      );
    },

    setPartnerTableRow: (state, action) => {
      const row: any = state.partnerTable.find(
        (x) => x.rowNumber == action.payload.rowNumber
      );
      if (!row) return;
      Object.entries(action.payload).forEach(([key, val]) => {
        if (Object.hasOwn(row, key)) row[key] = val;
      });
    },
    resetPartenerTable: (state) => {
      state.partnerTable = [
        {
          rowNumber: crypto.randomUUID(),
          customerCode: "",
          liner: "",
          attachmentName: "",
          serverName: null,
          serverPath: null,
          loading: 0,
          remove: true,
          m: true,
          error: {
            attachment: false,
            customerCode: false,
          },
          customerCodeErrorMessage: "",
        },
      ]
    },
    setPartnerTableCols: (state, action) => {
      // const row: any = state.partnerTable.find(
      //   (x) => x.rowNumber == action.payload.rowNumber
      // );
      // if (!row) return;
      state.partnerTable.forEach((item: any) => {
        Object.entries(action.payload).forEach(([key, val]) => {
          if (Object.hasOwn(item, key)) item[key] = val;
        });
      });
    },

    updateSelectedCountry: (state, action: PayloadAction<any>) => {
      state.selectedCountry = action.payload;
    },

    // validationCheckCustomerCodeMap: (state) => {


    //   state.partnerTable.forEach((item) => {
    //     item.error.attachment = !!(
    //       item.m &&
    //       (item.serverPath == null || item.loading != 100)
    //     );
    //     item.error.customerCode = !!(
    //       item.customerCode.trim() == ""
    //     );
    //   });
    // },
    clearCustomerMappingReqFiles: (state) => {

      state.partnerTable.forEach((row) => {
        row.attachmentName = "";
        row.serverName = null;
        row.serverPath = null;
        row.loading = 0;
      });

    },


  },
  extraReducers: (builder) => {

    builder.addCase(submitCustomerCodeRequest.fulfilled, (state, action) => {
      const { success, error, errorMessages } = action.payload;
      
      if (errorMessages?.length) {
        state.partnerTable.forEach((row) => {
          const backendError = errorMessages?.find(
            (err: any) => err.rowNumber == row.rowNumber
          );
          if (backendError) {
            row.error.customerCode = true;
            row.customerCodeErrorMessage = backendError?.message;
          } else {
            row.error.customerCode = false;
            row.customerCodeErrorMessage = "";
          }
        });
      }
    })

    builder.addCase(getCustomerCodeDetails.pending, (state) => {
      state.customerCodeDataList = []
    })
    builder.addCase(getCustomerCodeDetails.fulfilled, (state, action) => {
      state.customerCodeDataList = action.payload
    })

  },
});

export const {

  updateCountryOptions,

  updateLinerOptions,
  addPartnerTableRow,
  removePartnerTableRow,
  setPartnerTableRow,
  updateSelectedCountry,
  setPartnerTableCols,
  // validationCheckCustomerCodeMap,
  clearCustomerMappingReqFiles,
  resetPartenerTable
} = CustomerCodeReducer.actions;

export default CustomerCodeReducer.reducer;
